<div class="hpanel margin-bottom-5" *ngIf="viewType=='MIN'">
  <div class="panel-heading hbuilt wig-c">
    {{ headerTitle }}
  </div>

  <div *ngIf="loadAPIcall" class="panel-body">
    <app-common-skeleton *ngIf="loadAPIcall" [countforView]="7" [NameOftheScreen]="'widgets'"></app-common-skeleton>
  </div>
  <div *ngIf="!loadAPIcall" class="panel-body">
    <div class="row">
      <div class="col-lg-12">
        <!-- No data message -->
        <div class="gs-empty" *ngIf="admin.length === 0">
          <span class="gs-empty-icon"><ng-icon name="tablerUsers"></ng-icon></span>
          <div class="gs-empty-title">No admins yet</div>
        </div>
        <!-- Admin list -->
        <div class="community-admin" *ngIf="admin.length > 0">
          <a class="pd-3" *ngFor="let item of admin | slice:0:10">
            <img *ngIf="item['photo']" title="{{item.fullName}}" [src]="imgUrl + item['photo']" (click)="route(item)">
            <div *ngIf="!item['photo']" (click)="route(item)" class="circles mr-rt-10" [style.background-color]="getColor(item?.fullName)" title="{{item.fullName}}">
              <div class="circle-text" [style.color]="getFullNameTextColor(item?.fullname)" style="font-weight: bold; font-size: 14px;">{{ getInitials(item?.fullName) }}</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
